import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { selectLoggedIn, selectUser } from "../../store/slices/auth/slice";
import { PageSkeleton, PanelSkeleton } from "./Skeleton";

const ProtectedRoute = ({ allowedRoles = null }) => {
  const loggedIn = useSelector(selectLoggedIn);
  const user = useSelector(selectUser);
  const location = useLocation();

  // Skeleton umesto crnog ekrana dok se auth/user proverava
  const guardSkeleton =
    location.pathname.startsWith("/admin-panel") ||
    location.pathname.startsWith("/bend-panel") ? (
      <PanelSkeleton />
    ) : (
      <PageSkeleton full />
    );

  // If authentication status is still loading
  if (loggedIn === null) {
    return guardSkeleton;
  }

  // If not logged in, redirect to login
  if (!loggedIn) {
    return <Navigate to="/login" replace />;
  }

  // If logged in but no role info, wait for user data
  if (!user?.role) {
    return guardSkeleton;
  }

  // Role-based access control
  const currentPath = location.pathname;

  // Početna stranica po roli
  const homeByRole = {
    admin: "/admin-panel/kontrolna-tabla",
    band: "/bend-panel/kontrolna-tabla",
    dj: "/admin-panel/radio",
  };

  // Admin trying to access band routes
  if (user?.role === "admin" && currentPath.startsWith("/bend-panel/")) {
    return <Navigate to={homeByRole.admin} replace />;
  }

  // Band trying to access admin routes
  if (user?.role === "band" && currentPath.startsWith("/admin-panel/")) {
    return <Navigate to={homeByRole.band} replace />;
  }

  // DJ sme samo na radio panel (uključujući podstranice, npr. /radio/nova)
  if (
    user?.role === "dj" &&
    (currentPath.startsWith("/bend-panel/") ||
      (currentPath.startsWith("/admin-panel/") &&
        !currentPath.startsWith("/admin-panel/radio")))
  ) {
    return <Navigate to={homeByRole.dj} replace />;
  }

  // If allowedRoles is specified, check role access
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    return <Navigate to={homeByRole[user?.role] || "/"} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
